<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-15 19:06:39
 * @LastEditTime: 2021-12-10 14:36:10
 * @LastEditors: chenguobiao
-->
<template>
  <div class="question-desc flex items-start justify-between" :class="[questionType]">
    <div class="question-desc__type">（{{QUESTION_TYPE_MAPPING_TITLE[questionType]}}）</div>
    <div class="question-desc__type flex-1 desc">{{desc}}<span class="score">（{{score}}分）</span></div>
    <div class="question-desc__type" v-if="!replay && questionType !== 'ai'">
      <countdown ref="clock" @timeOver="timeOver"></countdown>
    </div>
  </div>
</template>

<script>
import store from 'store'
import Countdown from '@/render/components/common/countdown'
import { QUESTION_TYPE_MAPPING_TITLE, WS_GAME_CONFIGS } from '@/config/const'

export default {
  inject: ['timeOver'],
  props: ['questionType', 'desc', 'score'],
  data() {
    return {
      replay: true,
      QUESTION_TYPE_MAPPING_TITLE
    }
  },
  components: {
    Countdown
  },
  mounted() {
    const replay = store.get(WS_GAME_CONFIGS).replay
    this.replay = replay
    if (!replay) this.start()
  },
  methods: {
    start() {
      this.$nextTick(() => {
        this.$refs.clock && this.$refs.clock.start()
      })
    },
    stop() {
      this.$nextTick(() => {
        this.$refs.clock && this.$refs.clock.stop()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .question-desc {
    padding: val(30) 0 val(20);
    &__type {
      font-size: val(24);
      color: #3E2C00;
      &.desc {
        padding-right: val(16);
      }
    }
    &.ai {
      padding-left: val(380);
      .question-desc__type {
        // width: val(380);
        &.desc {
          padding-right: val(348);
        }
      }
    }
  }
</style>
